import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  BuyflowProductOffering,
  LineItem,
} from 'anchor-shared/lib/model/interface/buyflowProductOffering';

import { VesselRateDAO } from '../../../../../core/services/dao/vesselRateDAO';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { unsubscribeFromAll } from '../../../../../core/pure-functions/rx-helper';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-vessel-total-price-dialog',
  templateUrl: './vessel-total-price-dialog.component.html',
  styleUrls: ['./vessel-total-price-dialog.component.scss'],
})
export class VesselTotalPriceDialogComponent implements OnInit, OnDestroy {
  halfDayLineItems: LineItem[] = null;
  fullDayLineItems: LineItem[] = null;
  discountExist: boolean;
  estimatedTax: number;
  estimatedTotal: number;
  totalBeforeDiscount: number;
  halfDaySelected = true;
  fullDaySelected = false;
  halfDayExist = false;
  fullDayExist = false;
  isDateSelected: boolean;
  vesselName: string;
  vesselId: number;
  products: BuyflowProductOffering[];
  vesselRateDao: VesselRateDAO;
  isMobile: any;
  subs: any = [];
  halfDayDiscountApplied: boolean;
  fullDayDiscountApplied: boolean;
  halfDayOriginalTotalPrice: number;
  fullDayOriginalTotalPrice: number;
  isBrowser: boolean;

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver,
    private dialogRef: MatDialogRef<VesselTotalPriceDialogComponent>,
    private vesselRateDAO: VesselRateDAO,
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(MAT_BOTTOM_SHEET_DATA) public bottomSheetData: any,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    const sub = this.breakpointObserver
      .observe(['(min-width: 960px)'])
      .subscribe((state: BreakpointState) => {
        this.isMobile = !state.matches;
      });
    this.subs.push(sub);
    let dataSource = null;
    if (this.isMobile) {
      dataSource = bottomSheetData;
    } else {
      dataSource = data;
    }
    if (dataSource) {
      this.vesselName = dataSource.vesselName;
      this.vesselId = dataSource.vesselId;
      this.halfDayLineItems = dataSource.halfDayLineItems;
      this.fullDayLineItems = dataSource.fullDayLineItems;
      this.halfDayDiscountApplied = dataSource.halfDayDiscount;
      this.fullDayDiscountApplied = dataSource.fullDayDiscount;
      this.halfDayOriginalTotalPrice = dataSource.halfDayOriginalTotalPrice;
      this.fullDayOriginalTotalPrice = dataSource.fullDayOriginalTotalPrice;
      this.isDateSelected = dataSource.isDateSelected;
    }
  }

  ngOnInit() {
    this.checkForAvailableProducts();
    this.calculateProductEstimatedTax(this.halfDayExist);
    this.checkForDiscount(this.halfDaySelected, this.fullDaySelected);
    this.checkForDate();
  }

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }

  calculateBeforeDiscount(product: BuyflowProductOffering): void {
    const originalPriceSub = this.vesselRateDAO
      .getOriginalPriceBeforeDiscount(this.vesselId, product.duration)
      .subscribe((originalPrice) => {
        this.totalBeforeDiscount = Number(originalPrice);
        this._changeDetectorRef.markForCheck();
      });
    this.subs.push(originalPriceSub);
  }

  toggleHalfFull(halfDaySelected, fullDaySelected): void {
    this.halfDaySelected = halfDaySelected;
    this.fullDaySelected = fullDaySelected;
    this.calculateProductEstimatedTax(halfDaySelected);
    this.checkForDiscount(halfDaySelected, fullDaySelected);
  }

  calculateProductEstimatedTax(isHalf: boolean): void {
    this.estimatedTax = 0;
    if (isHalf) {
      this.halfDayLineItems.forEach((item) => {
        this.estimatedTax += item.estimatedTax;
      });
      this.calculateProductTotal(this.estimatedTax, this.halfDayLineItems);
    } else {
      this.fullDayLineItems.forEach((item) => {
        this.estimatedTax += item.estimatedTax;
      });
      this.calculateProductTotal(this.estimatedTax, this.fullDayLineItems);
    }
  }

  calculateProductTotal(tax: number, lineItems: LineItem[]): void {
    this.estimatedTotal = 0;
    lineItems.forEach((item) => {
      this.estimatedTotal += item.price;
    });
    this.estimatedTotal += this.estimatedTax;
  }

  close() {
    this.dialogRef.close(null);
  }

  getClassForDurationType(isSelected) {
    if (isSelected) {
      return 'selected';
    }
    return 'not-selected';
  }

  private checkForAvailableProducts() {
    this.halfDayExist = !!this.halfDayLineItems;

    this.fullDayExist = !!this.fullDayLineItems;

    if (this.fullDayExist && !this.halfDayExist) {
      this.fullDaySelected = true;
      this.halfDaySelected = false;
    }
  }

  private checkForDiscount(halfDaySelected, fullDaySelected) {
    this.discountExist =
      (halfDaySelected && !!this.halfDayDiscountApplied) ||
      (fullDaySelected && !!this.fullDayDiscountApplied);
  }

  private checkForDate() {
    if (this.isBrowser) {
    }
  }
}
